<template>
  <div id="wrap" class="wrap_layout">
    <Header :rtrnAnimInsYn="state.rtrnAnimInsYn" @pass="pass" />
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <p class="tit mgt0">바이오(지문)인증 절차가 진행됩니다.</p>
          <p class="txt02">
            안내문구를 확인하시고,<br />시작버튼을 누르시면 인증화면으로
            이동합니다.
          </p>
          <ul class="point_check_list">
            <Accordion ref="docRef" :vo="state.vo">
              <div class="txt_point">
                상법 제731조(타인의 사망을 보험사고로 하는 보험계약에서는
                보험계약체결시 그 타인의 서면(전자문서를 포함)에 의한 동의를
                얻어야 한다) 및 동법 시행령 제44조의2에 따라, 지문정보를
                이용하여 전자서명을 한 사람이 보험계약에 동의한 본인임을
                확인합니다.
                <br /><br />
                수집한 지문은 특정 정보로 변환 및 암호화 되어 금융결제원
                가이드라인에 따라 금융결제원과 메리츠화재가 분산보관하여
                안전하게 관리됩니다.
              </div>
            </Accordion>
          </ul>
          <div class="btn_area masterBtn">
            <button type="button" class="btn_main" @click="reqFingerPrint()">
              <span>바이오(지문)인증 시작</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, inject, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import Header from "@/components/common/Header.vue";
import Accordion from "@/components/common/Accordion.vue";
import nativeBridge from "@/common/nativeBridge";

export default {
  name: "fingerPrintAth",
  components: {
    Header,
    Accordion,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const axios = inject("axios");
    const dialog = useDialog();

    const docRef = ref(null);

    onMounted(async () => {
      await load();
      util.saveLog("009", "바이오지문인증"); // 009 : 화면진입
      if (sessionUserInfo == null) {
        router.push({ name: "sessionExpired" });
        return;
      }

      docRef.value.sgnInpCompYn = true;
      docRef.value.expanded = true;

      window.ios_recv_message_from_fingerprint = (res, error) => {
        if (error) {
          if (res?.errMsg == "등록실패 0:DEVICE_FAIL") {
            dialog.alert("비접촉 지문촬영을 지원하지 않습니다");
          } else {
            dialog.alert(
              "0000-" + (res?.errMsg || "지문인증 오류. 다시 시도해 주세요.")
            );
          }
          return;
        }

        let {
          publicKeyVersion,
          regEncryptedKey,
          regEncryptedTemplate,
          regEncryptedTemplateHash,
          signEncryptedKey,
          signEncryptedTemplate,
          signEncryptedTemplateHash,
          bioLocalCd,
          sucYn,
          errMsg,
        } = res;
        if (sucYn == "1") {
          // dialog.alert(errMsg).then(() => {

          let reqBody = {
            authVendorCode: "002",
            reRegistration: "Y",
            compatTechCode: "10010" + transBioLocalCd(bioLocalCd),
            publicKeyVersion: publicKeyVersion,
            encryptedKey: regEncryptedKey,
            encryptedTemplateHash: regEncryptedTemplateHash,
            encryptedTemplate: regEncryptedTemplate,
            maInspeRegNo: sessionUserInfo.maInspeRegNo,
          };

          axios.json("/bioAthInf/retrieveTmplMng.do", reqBody).then((res) => {
            if (res.data.body.data?.responseCode == "0000") {
              let reqBody2 = {
                idKey: res.data.body.data.idKey,
                compatTechCode: "10010" + transBioLocalCd(bioLocalCd),
                authVendorCode: "002",
                publicKeyVersion: publicKeyVersion,
                encryptedKey: signEncryptedKey,
                encryptedTemplateHash: signEncryptedTemplateHash,
                encryptedTemplate: signEncryptedTemplate,
                documentHash: store.state.elcSgnInf.documentHash.toUpperCase(),
              };

              axios
                .json("/bioAthInf/retrieveBioElcSgn.do", reqBody2)
                .then((res) => {
                  if (res.data.body.data?.responseCode == "0000") {
                    let bioAthData = {
                      prctrNo: sessionUserInfo.prctrNo,
                      compatTechCode: reqBody2.compatTechCode,
                      documentHash:
                        store.state.elcSgnInf.documentHash.toUpperCase(),
                      signSerialNumber: res.data.body.data.signSerialNumber,
                      bizTypeCd: "CTL",
                      idKey: reqBody2.idKey,
                    };

                    axios
                      .json("/bioAthInf/saveBioAthInfStr.do", bioAthData)
                      .then((res) => {
                        // 성공
                        dialog.alert("정상적으로 인증되었습니다.").then(() => {
                          transfer();
                        });
                      });
                  } else {
                    // 실패
                    dialog.alert(
                      "0003-" +
                        (res.data.body.data?.responseCode || "9999") +
                        " : " +
                        (res.data.body?.errorMessage ||
                          "지문인증 오류. 다시 시도해 주세요.")
                    );
                  }
                });
            } else {
              dialog.alert(
                "0002-" +
                  (res.data.body.data?.responseCode || "9999") +
                  " : " +
                  (res.data.body?.errorMessage ||
                    "지문인증 오류. 다시 시도해 주세요.")
              );
            }
          });
          // })
        } else {
          dialog.alert(
            "0001-" + (res?.errMsg || "지문인증 오류. 다시 시도해 주세요.")
          );
        }
      };

      let param = {};
      param.srchTp = "03";
      param.orgStatCd = "1";
      param.orgTpCd = "2";

      //계약자가 내근직 OR 영업가족인지 판단하기 위한 조직정보 조회
      axios.json("/retrieveOrgBasInf.do", param).then(function (result) {
        //내근직 or 영업가족 필터
        let orgList = _.filter(result.data.row, function (info) {
          return info.orgTpCd == "2" && info.orgStatCd == "1";
        });

        if (orgList.length > 0) {
          variables.inempYn = true;
        } else {
          variables.inempYn = false;
        }
      });

      state.ctrBasInfCoVo = sessionUserInfo.ctrBasInfCoVo[0];

      let sbcpChnDivCd = state.ctrBasInfCoVo.sbcpChnDivCd;

      //TM채널 여부
      if (sbcpChnDivCd == "11" || sbcpChnDivCd == "12") {
        variables.sbcpChnFlag = true;
      } else {
        variables.sbcpChnFlag = false;
      }

      //갱신형 실손의료보험여부
      if (
        state.ctrBasInfCoVo.rpsPdCd == "61091" ||
        state.ctrBasInfCoVo.rpsPdCd == "60546" ||
        state.ctrBasInfCoVo.rpsPdCd == "60862" ||
        state.ctrBasInfCoVo.rpsPdCd == "60635"
      ) {
        variables.pmmiCovYn = true;
      } else {
        variables.pmmiCovYn = false;
      }
    });

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      currDateWithComma: util.formatDate(new Date(), "yyyy.mm.dd"),
      rtrnAnimInsYn: false,
      vo: {
        ctnsKdCdNm: "바이오(지문)인증 전자서명 안내",
      },
    });

    const variables = {
      inempYn: false,
      sbcpChnFlag: "",
      pmmiCovYn: false,
    };

    const reqFingerPrint = () => {
      if (!docRef.value.sgnInpCompYn) {
        dialog.alert("바이오 인증 전자서명 안내 전문을 확인하여 주세요.");
        return;
      }

      axios.json("/bioAthInf/retrievePubKey.do", {}).then((res) => {
        let { publicKeyVersion, publicKeyModulus } = res.data.body.data;
        let reqBridgeData = {
          ...res.data.body.data,
          msgList: [
            "1. 피보험자 : " + sessionUserInfo.maInspeNm,
            "2. 가계약번호 : " + sessionUserInfo.prctrNo,
            "3. 일자 : " + state.currDateWithComma,
          ],
        };
        nativeBridge
          .reqFingerPrint(reqBridgeData)
          .then((res) => {
            let {
              regEncryptedKey,
              regEncryptedTemplate,
              regEncryptedTemplateHash,
              signEncryptedKey,
              signEncryptedTemplate,
              signEncryptedTemplateHash,
              bioLocalCd,
              sucYn,
              errMsg,
            } = res;
            if (sucYn == "1") {
              // dialog.alert(errMsg).then(() => {

              let reqBody = {
                authVendorCode: "002",
                reRegistration: "Y",
                compatTechCode: "10010" + transBioLocalCd(bioLocalCd),
                publicKeyVersion: publicKeyVersion,
                encryptedKey: regEncryptedKey,
                encryptedTemplateHash: regEncryptedTemplateHash,
                encryptedTemplate: regEncryptedTemplate,
                maInspeRegNo: sessionUserInfo.maInspeRegNo,
              };

              axios
                .json("/bioAthInf/retrieveTmplMng.do", reqBody)
                .then((res) => {
                  if (res.data.body.data?.responseCode == "0000") {
                    let reqBody2 = {
                      idKey: res.data.body.data.idKey,
                      compatTechCode: "10010" + transBioLocalCd(bioLocalCd),
                      authVendorCode: "002",
                      publicKeyVersion: publicKeyVersion,
                      encryptedKey: signEncryptedKey,
                      encryptedTemplateHash: signEncryptedTemplateHash,
                      encryptedTemplate: signEncryptedTemplate,
                      documentHash:
                        store.state.elcSgnInf.documentHash.toUpperCase(),
                    };

                    axios
                      .json("/bioAthInf/retrieveBioElcSgn.do", reqBody2)
                      .then((res) => {
                        if (res.data.body.data?.responseCode == "0000") {
                          let bioAthData = {
                            prctrNo: sessionUserInfo.prctrNo,
                            compatTechCode: reqBody2.compatTechCode,
                            documentHash:
                              store.state.elcSgnInf.documentHash.toUpperCase(),
                            signSerialNumber:
                              res.data.body.data.signSerialNumber,
                            bizTypeCd: "CTL",
                            idKey: reqBody2.idKey,
                          };

                          axios
                            .json("/bioAthInf/saveBioAthInfStr.do", bioAthData)
                            .then((res) => {
                              // 성공
                              dialog
                                .alert("정상적으로 인증되었습니다.")
                                .then(() => {
                                  transfer();
                                });
                            });
                        } else {
                          // 실패
                          dialog.alert(
                            "0003-" +
                              (res.data.body.data?.responseCode || "9999") +
                              " : " +
                              (res.data.body?.errorMessage ||
                                "지문인증 오류. 다시 시도해 주세요.")
                          );
                        }
                      });
                  } else {
                    dialog.alert(
                      "0002-" +
                        (res.data.body.data?.responseCode || "9999") +
                        " : " +
                        (res.data.body?.errorMessage ||
                          "지문인증 오류. 다시 시도해 주세요.")
                    );
                  }
                });
              // })
            } else {
              dialog.alert(
                "0001-" + (res?.errMsg || "지문인증 오류. 다시 시도해 주세요.")
              );
            }
          })
          .catch((res) => {
            dialog.alert(
              "0000-" + (res?.errMsg || "지문인증 오류. 다시 시도해 주세요.")
            );
          });
      });
    };

    const pass = () => {
      transfer();
    };

    function transBioLocalCd(code) {
      let localCd = "01";
      switch (code) {
        case "1":
          localCd = "08";
          break;
        case "2":
          localCd = "09";
          break;
        case "3":
          localCd = "10";
          break;
        case "4":
          localCd = "11";
          break;
        case "5":
          localCd = "12";
          break;
        case "6":
          localCd = "03";
          break;
        case "7":
          localCd = "04";
          break;
        case "8":
          localCd = "05";
          break;
        case "9":
          localCd = "06";
          break;
        case "10":
          localCd = "07";
          break;
      }
      return localCd;
    }

    function transfer() {
      if (store.state.elcSgnInf.sgnTrnsFlag) {
        router.push({ name: "elcSgnComp" });
        return;
      }

      let date = util.formatDate(new Date(), "yyyymmdd");

      if (sessionUserInfo.inqStdDt != date) {
        dialog.alert("모바일전자서명은 발송당일만 서명전송이 가능합니다.");
        return;
      }

      let param = _.cloneDeep(sessionUserInfo);
      param.currentDate = util.formatDate(new Date(), "yyyymmdd");
      param = _.merge(param, store.state.elcSgnInf.acntInf);
      param.imageList = store.state.elcSgnInf.imageData;
      param.agrInf = store.state.elcSgnInf.agrInf;

      let inspeTrgCoVo = _.filter(
        store.state.elcSgnInf.elcSgnTrgCoVo,
        (data) => data.ptyRlCd.indexOf("02") >= 0
      )[0];

      //예금주 당사자 존재여부 확인
      if (inspeTrgCoVo.ptyRlCd.indexOf("71") >= 0) {
        param.dporElcSgnYn = "Y";
      } else {
        param.dporElcSgnYn = "N";
      }

      // 출력물 생성 및 전송, 발송
      axios.json("/inspe/transferInspeSgn.do", param).then(function (result) {
        store.commit("elcSgnInf/changeSgnTrnsFlag", true);
        util.saveLog("003", "서명전송"); // 003 : 저장
        if (
          util.isEmpty(store.state.elcSgnInf.maInspeAge) ||
          store.state.elcSgnInf.maInspeAge >= 65 ||
          store.state.elcSgnInf.maInspeAge <= 18 ||
          (variables.sbcpChnFlag && variables.pmmiCovYn) ||
          variables.inempYn
        ) {
          dialog
            .alert(
              "전화가입을 통한 갱신형 실손의료비 담보가입, " +
                "미성년자,만65세 이상 , 저축/연금 보험 또는 당사 설계사 임직원으로 체결된 계/피 동일계약 가입고객님께서는 " +
                "모바일 모니터링이 어렵습니다. 해피콜 1577-7711로 연락드리겠습니다. " +
                "감사합니다."
            )
            .then(function () {
              router.push({ name: "elcSgnComp" });
            });
        } else {
          dialog
            .confirm(
              "보험업감독업무시행세칙 제2-34조의 23항(보험계약 중요사항의 설명의무 등)에 따라 완전판매모니터링 신청시 동의가 필요합니다.<br/>모바일을 이용한 완전판매모니터링에 동의하시겠습니까?"
            )
            .then(function (data) {
              if (data == "1") {
                // 완전판매 모니터링 설문조사 페이지로 이동
                router.push({ name: "cmpltSal" });
              } else if (data == "2") {
                // 완료페이지로 이동
                router.push({ name: "elcSgnComp" });
              }
            });
        }
      });
    }

    return {
      state,
      load,
      sessionUserInfo,
      reqFingerPrint,
      docRef,
      pass,
    };
  },
};
</script>
